export class GraphQLNetworkError extends Error {
    name = 'GraphQLNetworkError';

    constructor(
        message: string,
        public readonly endpointKey: string,
        public readonly cause?: unknown
    ) {
        super(message);
    }
}

export function isGraphQLNetworkError(error: unknown): error is GraphQLNetworkError {
    return error instanceof GraphQLNetworkError
        || (error instanceof Error && error.name === 'GraphQLNetworkError');
}

export function isTransientGraphQLHttpStatus(status: number): boolean {
    return status === 408 || status === 429 || status === 502 || status === 503 || status === 504;
}

export function isTransientFetchError(error: unknown): boolean {
    if (isGraphQLNetworkError(error)) {
        return true;
    }

    if (!(error instanceof Error)) {
        return false;
    }

    return error.name === 'TypeError'
        || error.name === 'AbortError'
        || error.message === 'Failed to fetch'
        || error.message.includes('NetworkError')
        || error.message.includes('Load failed');
}
